<template>
  <AppHeader>Add Delivery Person</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="flex flex-col p-3 bg-white rounded-2xl shadow-sm">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Name</p>
        <input v-model="form.name" ref="inputName" class="w-full text-xl placeholder:text-lg" placeholder="Enter person name" type="text">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.name">{{ errors.name }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Phone</p>
        <input v-model="form.phone" class="w-full text-xl placeholder:text-lg" placeholder="Enter phone number" type="text">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.phone">{{ errors.phone }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Date of Birth</p>
        <input v-model="form.dob" class="w-full text-xl placeholder:text-lg" placeholder="Enter Date of birth" type="date">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.dob">{{ errors.dob }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Address</p>
        <textarea v-model="form.address" class="w-full text-xl placeholder:text-lg" placeholder="Enter full address"></textarea>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.address">{{ errors.address }}</p>
      </div>
    </div>

    <div class="w-full">
      <div class="flex items-center justify-between px-2 py-1 mt-2 border-2 bg-white rounded-lg shadow border-slate-100">
        <div class="flex-1">
          <label class="text-base text-gray-600 font-ubuntu">PAN Card</label>
          <input type="text" v-model="form.id_pan" placeholder="Enter PAN number" class="w-full text-lg outline-none"/>
        </div>

        <label class="ml-3">
          <input type="file" class="hidden" accept="image/*" @change="handleFileUpload($event, 'pan')"/>
          <span class="px-2 py-1 text-sm leading-none text-gray-600 rounded-full bg-slate-300">{{ uploadedFiles.pan ? 'Uploaded' : 'Attach file' }}</span>
        </label>
      </div>

      <div class="flex items-center justify-between px-2 py-1 mt-2 border-2 rounded-lg shadow border-slate-100 bg-white">
        <div class="flex-1">
          <label class="text-base text-gray-600 font-ubuntu">Aadhar Card</label>
          <input type="text" v-model="form.id_aadhaar" placeholder="Enter Aadhar number" class="w-full text-lg outline-none"/>
        </div>

        <label class="ml-3">
          <input type="file" required class="hidden" accept="image/*" @change="handleFileUpload($event, 'aadhaar')"/>
          <span class="px-2 py-1 text-sm leading-none text-gray-600 rounded-full bg-slate-300">{{ uploadedFiles.aadhaar ? 'Uploaded' : 'Attach file' }}</span>
        </label>
      </div>

      <div class="flex items-center justify-between px-2 py-1 mt-2 border-2 rounded-lg shadow bg-white">
        <div class="flex-1">
          <label class="text-base text-gray-600 font-ubuntu">License</label>
          <input type="text" v-model="form.id_license" placeholder="Enter License number" class="w-full text-lg outline-none"/>
        </div>

        <label class="ml-3">
          <input type="file" class="hidden" accept="image/*" @change="handleFileUpload($event, 'license')"/>
          <span class="px-2 py-1 text-sm leading-none text-gray-600 rounded-full bg-slate-300">{{ uploadedFiles.license ? 'Uploaded' : 'Attach file' }}</span>
        </label>
      </div>
    </div>
    <div class="mt-5 text-center">
      <button class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300" @click="create">Create</button>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import formMixin from '@/utils/mixins/form.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'CreateDeliveryPerson',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'idle',
      form: {},
      uploadedFiles: {
        pan: false,
        aadhaar: false,
        license: false,
      }
    }
  },

  methods: {
    async handleFileUpload(event, type) {
      const file = event.target.files[0];

      if (!file) return;

      const compressedFile = await this.compressImage(file);

      const maxSize = 2 * 1024 * 1024;

      if (compressedFile.size > maxSize) {
        alert('Image size should be less than 2 MB.');
        event.target.value = '';
        return;
      }

      if(type === 'pan') {
        this.form.pan_image = compressedFile;
      } else if(type === 'aadhaar') {
        this.form.aadhaar_image = compressedFile;
      } else if(type === 'license') {
        this.form.license_image = compressedFile;
      }

      this.uploadedFiles[type] = true;
    },

    create() {
      let rules = {
        name: 'required|notempty',
        phone: 'required|notempty',
      };

      if (!this.validateForm(this.form, rules)) return;
      if (!(this.form.aadhaar_image instanceof Blob)) {
        alert('Please upload Aadhaar image.');
          return;
      }

      if (!confirm('Are you sure?')) return;

      this.state = 'loading';

      const formData = new FormData();

      Object.entries(this.form).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            formData.append(key, value);
        }
      });
      this.request('POST', 'delivery-persons', formData, (resp) => {
        alert(resp.message);
        this.state = 'idle';
        if (resp.success) {
          this.$router.go(-1);
        }
      });
    },
  },

  mounted() {
    this.$refs.inputName.focus();
  },
}
</script>
